'use strict';
const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = ({viewClass, isEnabled = () => true}) => {
    return createWidgetFactory({
        viewClass,
        isEnabled,
        name: 'aircraftmap_legend',
        methods: {
            updateSeatTypes: function(types) {
                this.updateSeatTypes(types);
            },
        },
    });
};
